export enum GridDomLayout {
  AutoHeight = 'autoHeight',
  Normal = 'normal',
  Print = 'print',
}
